import { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";

export const useTheme = () => {
  const [searchParams] = useSearchParams();
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check for saved theme or system preference
    const savedTheme = localStorage.getItem('tradingTheme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
    const shouldUseDark = savedTheme === 'dark' || (!savedTheme && prefersDark);
    
    setIsDarkMode(shouldUseDark);
    updateThemeClass(shouldUseDark);
  }, []);

  const updateThemeClass = (darkMode) => {
    const html = document.documentElement;
    if (darkMode) {
      html?.classList?.add('dark');
    } else {
      html?.classList?.remove('dark');
    }


    const getTheme = searchParams.get("theme");

    if(getTheme)
    {
      if(getTheme == 'dark')
      {
        localStorage.setItem('tradingTheme', 'dark');
        html?.classList?.add('dark');
      }else{
        localStorage.setItem('tradingTheme', 'light');
        html?.classList?.remove('dark');
      }
    }
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem('tradingTheme', newTheme ? 'dark' : 'light');
    updateThemeClass(newTheme);
  };

  const setTheme = (theme) => {
    const darkMode = theme === 'dark';
    setIsDarkMode(darkMode);
    localStorage.setItem('tradingTheme', theme);
    updateThemeClass(darkMode);
  };

  return {
    isDarkMode,
    toggleTheme,
    setTheme,
    theme: isDarkMode ? 'dark' : 'light'
  };
};

export default useTheme;